import React, { useState,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../assets/css/SignUp.css';
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImage from '../../assets/images/tennis-court.jpg';
import { IoIosArrowBack } from "react-icons/io";


const ConfirmationCode = () => {
    const [code, setCode] = useState(["", "", "", ""]);
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;
    const [loader, setLoader] = useState(false);
   const [resendVisible, setResendVisible] = useState(false);



    const onConfirmationCode = async () => {
        const joinedCode = code.join("");

        // Validation: ensure all digits are entered
        if (joinedCode.length !== 4 || code.includes("")) {
            toast.error("Please enter the 4-digit confirmation code.");
            return;
        }

        try {
            const data = {
                OTP: joinedCode,
                emailOrMobile: email,
            };

            const result = await apiHandler({
                url: endpoint.SIGN_UP_OTP_VERIFY,
                method: "POST",
                data: data,
            });

            if (result.data.message) {
                toast.success(result.data.message || "User is already active");
                navigate('/create-new-password', {
                    state: {
                        email,
                        code: joinedCode,
                    },
                });
            } else {
                toast.error(result.message || 'Invalid OTP. Please try again.');
            }
        } catch (error) {
            toast.error('Failed to verify OTP. Please check your connection or try again later.');
        }
    };


    const handleInputChange = (e, index) => {
        const value = e.target.value;

        // Allow only digits
        if (!/^\d?$/.test(value)) return;

        const newCode = [...code];
        newCode[index] = value;
        setCode(newCode);

        if (value && index < 3) {
            document.getElementById(`code-${index + 1}`).focus();
        }
    };

    const handleBackspace = (e, index) => {
        if (e.key === "Backspace" && !code[index] && index > 0) {
            document.getElementById(`code-${index - 1}`).focus();
        }
    };

    useEffect(() => {
    const timer = setTimeout(() => {
        setResendVisible(true);
    }, 30000); 

    return () => clearTimeout(timer); 
}, []);

  const onResendOTP = async () => {
    setLoader(true);
    setResendVisible(false); 

    const identifier = email;
    try {
        const url = `${endpoint.FORGET_PASSWORD}?identifier=${encodeURIComponent(identifier)}`;
        const result = await apiHandler({ url, method: "GET" });

        if (result.data.message === "Password reset instructions sent successfully.") {
            toast.success('Reset Password Successfully');
        } else {
            toast.error(result.data.message || "Something went wrong. Please try again.");
        }
    } catch (error) {
        toast.error(error.message || "An unexpected error occurred.");
    } finally {
        setLoader(false);
        // Re-enable after 30 seconds if needed
        setTimeout(() => setResendVisible(true), 30000);
    }
};


    return (
        <div className="d-flex justify-content-center align-items-center" style={{
            backgroundImage: `url(${loginImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            height: '100%',
            width: '100%',
            position: 'absolute',
        }}>
            <div className="border p-4 d-flex align-items-center justify-content-center" style={{ width: '407px', background: 'white', opacity: '0.9', height: '400px' }}>
                <div style={{ width: '90%' }} >
                   
                    <h4 className="mb-3 text-center  confirmation-code-txt">Enter confirmation code</h4>
                    <p className="text-muted text-center mb-4">
                        A 4-digit code was sent to <br />
                        <strong>{email}</strong>
                    </p>
                    <div className="d-flex gap-3 justify-content-center">
                        {code.map((digit, index) => (
                            <input
                                key={index}
                                id={`code-${index}`}
                                type="text"
                                inputMode="numeric"
                                pattern="\d*"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleInputChange(e, index)}
                                onKeyDown={(e) => handleBackspace(e, index)}
                                className="form-control text-center code-input"
                            />

                        ))}
                    </div>
                    {resendVisible && (
                        <div className="resend-otp-txt text-center" onClick={onResendOTP}>Resend OTP</div>
                    )}
                    <div className="mt-4">
                        <CustomButton buttonText={loader ? ' Reset Password' : 'Continue'} style={{ width: '327px', height: '48px', borderRadius: '12px', background: '#006FFD', color: '#FFFFFF', border: 'none' }} onClick={onConfirmationCode} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationCode;
